import React from 'react';
import { Card, Form } from 'react-bootstrap';
import { TEXT_SIZES, setTextSize, useTextSize } from '../utils/textSize';

/** Settings > Text size: makes everything bigger (or back to the compact default) in this browser. */
function TextSizeSettings() {
  const size = useTextSize();

  return (
    <Card className="mb-4" data-testid="text-size-settings">
      <Card.Header>
        <h5 className="mb-0">Text size</h5>
      </Card.Header>
      <Card.Body>
        <p className="text-muted small">
          Makes the text and everything around it bigger, on this browser. You can also press Ctrl or Cmd and + at any time.
        </p>
        <Form role="radiogroup" aria-label="Text size">
          {TEXT_SIZES.map((s) => (
            <Form.Check
              key={s.key}
              type="radio"
              name="text-size"
              id={`text-size-${s.key}`}
              label={s.label}
              checked={size === s.key}
              onChange={() => setTextSize(s.key)}
              className="mb-1"
            />
          ))}
        </Form>
      </Card.Body>
    </Card>
  );
}

export default TextSizeSettings;
